import { render, staticRenderFns } from "./OdocForm.vue?vue&type=template&id=76b2b022"
import script from "./OdocForm.vue?vue&type=script&lang=js"
export * from "./OdocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports